// Module
var code = `{%- liquid
  assign color_display_value = _product.metafields.global.style | default: _product.options_by_name['color'].values[0]
  for tag in _product.tags
    assign lower_tag = tag | downcase
    if lower_tag contains 'description:'
      assign color_display_value = tag | split: ':' | last
      break
    endif
  endfor
  echo color_display_value
-%}`;
// Exports
export default code;